import { createTheme } from "@mui/material";
import { TextField } from "@mui/material";

const theme = createTheme({
  typography: {
    h5: {
      fontSize: "1.35rem",
      fontWeight: 600,
      lineHeight: 1.3,
    },
  },
  palette: {
    primary: {
      main: "#3a6542",
      light: "#629c71",
      dark: "#25482e",
      contrastText: "#FFFFFF"
    },
    secondary: {
      // main: "#4dcd75"
      main: "#5F6F64"
    }
  },
  components: {
    MuiLink: {
      defaultProps: { underline: "hover" },
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.primary.main,
          "&:visited": { color: theme.palette.primary.main },
          "&:hover": { color: theme.palette.primary.main, textDecoration: "underline" },
          "&:focus-visible": {
            outline: `2px solid ${theme.palette.primary.main}`,
            outlineOffset: "2px",
            textDecoration: "underline",
          },
        }),
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none"
        },
        containedPrimary: {
          "&:hover": {
            backgroundColor: "#5d936b"
            // backgroundColor: "#00fd3f"
          }
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&.MuiTableRow-hover:hover": {
            backgroundColor: "#F5F5F5"
          },
          "&.Mui-selected": {
            backgroundColor: "#E3F1E6"
          },
          "&.Mui-selected.MuiTableRow-hover:hover": {
            backgroundColor: "#D7EADB"
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          whiteSpace: "nowrap",
          "& .MuiTextField-root": {
            marginTop: 0,
            marginBottom: 0
          }
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        margin: "dense",
        sx: { marginBottom: "12px" }
      }
    },
    MuiDatePicker: {
      defaultProps: {
        renderInput: (params) => <TextField {...params} margin="dense" sx={{ marginBottom: "12px" }} />
      }
    }
  }
});

export default theme;
